export default "__VITE_ASSET__DlumEuhn__"